export enum LocalStorageKeyEnum {
  USER = 'USER',
  PERMISSIONS = 'PERMISSIONS',
  PERMISSIONS_DOT_ANNOTATION = 'PERMISSIONS_DOT_ANNOTATION',
  PERSONA_START_DATE = 'PERSONA_START_DATE',
  SINGLE_PERSONA_VIEW = 'SINGLE_PERSONA_VIEW',
  PHOTO = 'FOTO'
}
